import { render, staticRenderFns } from "./ThemeSyncToggle.vue?vue&type=template&id=c123777c&scoped=true"
import script from "./ThemeSyncToggle.vue?vue&type=script&lang=js"
export * from "./ThemeSyncToggle.vue?vue&type=script&lang=js"
import style0 from "./ThemeSyncToggle.vue?vue&type=style&index=0&id=c123777c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c123777c",
  null
  
)

export default component.exports